export default __webpack_public_path__ + "static/media/gear.005f8b98.svg";